import OtsTableNew from "./OtsTableNew"

OtsTableNew.install = Vue => {
    vue.component(OtsTable.name,OtsTableNew)
}


export default OtsTableNew